import { Component, Injector, Input, TemplateRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';


@Component({
  selector: 'list-single-filter-v2',
  templateUrl: './list-single-filter-v2.component.html',
  styleUrls: ['./list-single-filter-v2.component.scss']
})
export class ListSingleFilterV2Component {

  @Input() iconUrl: string;
  @Input() name: string;
  @Input() form: UntypedFormGroup;
  @Input() controlName: string;
  @Input() control: UntypedFormControl;
  @Input() template: TemplateRef<any>;

  injector: Injector;

  constructor() {
  }

  get isValue() {
    if (this.control) {
      return this.control.value && this.control.value.toString().length;
    }
    return this.form?.value[this.controlName] && this.form?.value[this.controlName].toString().length;
  }

}
